export const TYPES = [
  {
    id: 'team',
    title: 'sidebar.switch.team',
    icon: './assets/switch/team.svg',
  },
  {
    id: 'person',
    title: 'sidebar.switch.person',
    icon: './assets/switch/person.svg',
  },
];

export const TEAM = [
  {
    id: 'total',
    link: '/team/total',
    title: 'sidebar.team.total',
    icon: './assets/menu/team_common.svg',
  },
  // {
  //   id: 'scope',
  //   link: '/team/scope',
  //   title: 'sidebar.team.scope',
  //   icon: './assets/menu/team_feat.svg',
  // },
  {
    id: 'author',
    link: '/team/author',
    title: 'sidebar.team.author',
    icon: './assets/menu/team_work.svg',
  },
  // {
  //   id: 'type',
  //   link: '/team/type',
  //   title: 'sidebar.team.type',
  //   icon: './assets/menu/team_type.svg',
  // },
  // {
  //   id: 'company',
  //   link: '/team/company',
  //   title: 'sidebar.team.company',
  //   icon: './assets/menu/company.svg',
  // },
  // {
  //   id: 'country',
  //   link: '/team/country',
  //   title: 'sidebar.team.country',
  //   icon: './assets/menu/country.svg',
  // },
  {},
  {
    id: 'day',
    link: '/team/day',
    title: 'sidebar.team.day',
    icon: './assets/menu/team_day.svg',
  },
  {
    id: 'week',
    link: '/team/week',
    title: 'sidebar.team.week',
    icon: './assets/menu/team_week.svg',
  },
  {
    id: 'month',
    link: '/team/month',
    title: 'sidebar.team.month',
    icon: './assets/menu/team_month.svg',
  },
  {
    id: 'hours',
    link: '/team/hours',
    title: 'sidebar.team.hours',
    icon: './assets/menu/team_hours.svg',
  },
  {},
  {
    id: 'files',
    link: '/team/files',
    title: 'sidebar.team.files',
    icon: './assets/menu/team_files.svg',
  },
  {
    id: 'removedFiles',
    link: '/team/removedFiles',
    title: 'sidebar.team.removedFiles',
    icon: './assets/menu/team_files_remove.svg',
  },
  {
    id: 'extension',
    link: '/team/extension',
    title: 'sidebar.team.extension',
    icon: './assets/menu/team_files_ext.svg',
  },
  {
    id: 'refactor',
    link: '/team/refactor',
    title: 'sidebar.team.refactor',
    icon: './assets/menu/refactor.svg',
  },
  {},
  {
    id: 'release',
    link: '/team/release',
    title: 'sidebar.team.release',
    icon: './assets/menu/team_release.svg',
  },
  {
    id: 'tasks',
    link: '/team/tasks',
    title: 'sidebar.team.tasks',
    icon: './assets/menu/team_tasks.svg',
  },
  {
    id: 'pr',
    link: '/team/pr',
    title: 'sidebar.team.pr',
    icon: './assets/menu/pull_request.svg',
  },
  {},
  {
    id: 'commits',
    link: '/team/commits',
    title: 'sidebar.team.commits',
    icon: './assets/menu/pull-request.svg',
  },
  {
    id: 'changes',
    link: '/team/changes',
    title: 'sidebar.team.changes',
    icon: './assets/menu/branch.svg',
  },
  {
    id: 'words',
    link: '/team/words',
    title: 'sidebar.team.words',
    icon: './assets/menu/team_words.svg',
  },
];

export const PERSON = [
  {
    id: 'total',
    link: '/person/total/',
    title: 'sidebar.person.total',
    icon: './assets/menu/team_common.svg',
  },
  // {
  //   id: 'money',
  //   link: '/person/money/',
  //   title: 'sidebar.person.money',
  //   icon: './assets/menu/per_money.svg',
  // },
  {
    id: 'speed',
    link: '/person/speed/',
    title: 'sidebar.person.speed',
    icon: './assets/menu/per_speed.svg',
  },
  {},
  {
    id: 'day',
    link: '/person/day/',
    title: 'sidebar.person.day',
    icon: './assets/menu/team_day.svg',
  },
  {
    id: 'week',
    link: '/person/week/',
    title: 'sidebar.person.week',
    icon: './assets/menu/team_week.svg',
  },
  {
    id: 'month',
    link: '/person/month/',
    title: 'sidebar.person.month',
    icon: './assets/menu/team_month.svg',
  },
  {
    id: 'hours',
    link: '/person/hours/',
    title: 'sidebar.person.hours',
    icon: './assets/menu/team_hours.svg',
  },
  {},
  {
    id: 'tasks',
    link: '/person/tasks/',
    title: 'sidebar.person.tasks',
    icon: './assets/menu/team_tasks.svg',
  },
  {},
  {
    id: 'commits',
    link: '/person/commits/',
    title: 'sidebar.person.commits',
    icon: './assets/menu/pull-request.svg',
  },
  {
    id: 'changes',
    link: '/person/changes/',
    title: 'sidebar.person.changes',
    icon: './assets/menu/branch.svg',
  },
  {
    id: 'words',
    link: '/person/words/',
    title: 'sidebar.person.words',
    icon: './assets/menu/team_words.svg',
  },
];
